/* ═══════════════════════════════════════════════════════
   config.js — Centralized configuration & assets
   ═══════════════════════════════════════════════════════ */

// ───── Images ─────
import logoFooter from "../assets/logo-footer.png";
import googlePlay from "../assets/google-download.svg";
import appStore from "../assets/app-download.svg";
import testFlight from "../assets/tf.png";
import apkFile from '../assets/apk.png'

import iconTiktok from '../assets/social/tiktok-icon.svg'
import iconYoutube from '../assets/social/youtube-icon.svg'
import iconFacebook from '../assets/social/facebook-icon.svg'
import iconInstagram from '../assets/social/instagram-icon.svg'
import iconThreads from '../assets/social/threads-icon.svg'

import screenshot1 from "../assets/screenshots/IMG_1500.webp";

import { importAll } from "../utils/helper";

// ───── Asset Exports ─────`
export const IMAGES = {
  logo: logoFooter,
  googlePlay,
  appStore,
  testFlight: testFlight,
  apkFile: apkFile,
  iconTiktok: iconTiktok,
  iconYoutube: iconYoutube,
  iconFacebook: iconFacebook,
  iconInstagram: iconInstagram,
  iconThreads: iconThreads,
};

export const APP_SCREENSHOTS = importAll(
  require.context("../assets/screenshots", false, /\.(webp)$/)
);

export const ANDROID_GUIDE = importAll(
  require.context("../assets/guide/android", false, /\.(webp|png|PNG|jpe?g|svg)$/)
);

export const IOS_GUIDE = importAll(
  require.context("../assets/guide/ios", false, /\.(webp|png|PNG|jpe?g|svg)$/)
);

// ───── Links ─────
export const LINKS = {
  android: {
    direct: "https://clts-space.sgp1.cdn.digitaloceanspaces.com/app/android/colascore-v1.5.1.apk?appVersion=1.5.1&buildNumber=151",
    store: "https://play.google.com/store/apps/details?id=com.app.dev.tools",
  },
  ios: {
    direct: "https://testflight.apple.com/join/8wC6pywW?appVersion=1.5.1&buildNumber=151",
    store: "https://apps.apple.com/us/app/colascore-ball/id6783248501",
  },
  social: {
    tiktok: "https://www.tiktok.com/@colascore7?_r=1&_t=ZS-95OQSEuzD8O",
    youtube: "https://www.youtube.com/channel/UCc3Gah2AFApnc-Xzq1_Y3Ag",
    facebook: "https://www.facebook.com/ColaScore.bongda",
    instagram: "https://www.instagram.com/colascore?igsh=OGQ5ZDc2ODk2ZA==",
    threads: 'https://www.threads.com/@colascore07?igshid=NTc4MTIwNjQ2YQ=='
  },
};

// ───── Text Content ─────
export const CONTENT = {
  header: {
    title: "APP Theo Dõi Tỷ Số Bóng Đá - Trực Tiếp Bóng Đá",
    subtitle: "Tải ứng dụng trên thiết bị của bạn — nhanh chóng và tiện lợi",
  },
  features: [
    {
      value: "Cập nhật tỉ số trực tiếp",
      sub: "Theo dõi kết quả, bàn thắng và diễn biến trận đấu nhanh chóng",
    },
    {
      value: "Cập nhật tỉ số nhanh và chính xác",
      sub: "Cập nhật tỉ số và sự kiện trận đấu ngay khi diễn ra",
    },
    {
      value: "Tất cả thông tin trận đấu trong tầm tay",
      sub: "Theo dõi tỉ số, lịch thi đấu, đội hình và thống kê chi tiết",
    },
  ],
  footer: {
    description:
      "COLASCORE là trang web chuyên cung cấp tỷ số bóng đá trực tuyến nhanh chóng và chính xác, giúp người hâm mộ cập nhật diễn biến trận đấu theo thời gian thực. Với nền tảng hiện đại, COLASCORE không chỉ tập trung vào kết quả bóng đá mà còn mở rộng thông tin ra nhiều môn thể thao khác như bóng rổ, tennis, giúp người dùng theo dõi đa dạng và toàn diện. Bên cạnh đó, hệ thống dự đoán kết quả bóng đá của COLASCORE được xây dựng bởi đội ngũ chuyên gia giàu kinh nghiệm, mang lại góc nhìn chiến thuật và phân tích chuyên sâu cho từng trận đấu.",
    copyright: "colascore.com / All rights reserved.",
  },
  labels: {
    downloadApp: "Tải ứng dụng",
    screenshots: "Ảnh chụp màn hình",
    fullVersion: "Bản đầy đủ",
    apkVersion: "File APK",
    testFlight: "TestFlight",
  },
  links: {
    installGuide: {
      android: "#",
      ios: "#",
    },
  },
  installGuide: {
    android: [
      {
        title: "Tải file APK",
        description: "Nhấn vào nút tải xuống hoặc quét mã QR để tải file APK.",
        image: ANDROID_GUIDE[0],
      },
      {
        title: "Mở file vừa tải",
        description: "Vào mục Thông báo hoặc thư mục Tải xuống, nhấn vào file APK.",
        image: ANDROID_GUIDE[1],
      },
      {
        title: "Cho phép cài từ nguồn không xác định",
        description: "Khi được hỏi, nhấn Cài đặt → Bật 'Cho phép từ nguồn này'.",
        image: ANDROID_GUIDE[2],
      },
      {
        title: "Xác nhận cài đặt",
        description: "Nhấn 'Cài đặt' để bắt đầu quá trình cài ứng dụng.",
        image: ANDROID_GUIDE[3],
      },
      {
        title: "Chờ cài đặt hoàn tất",
        description: "Đợi vài giây để hệ thống cài đặt ứng dụng.",
        image: ANDROID_GUIDE[4],
      },
      {
        title: "Mở ứng dụng",
        description: "Nhấn 'Mở' để khởi chạy ứng dụng lần đầu.",
        image: ANDROID_GUIDE[5],
      },
      {
        title: "Đăng nhập & sử dụng",
        description: "Đăng nhập tài khoản và bắt đầu sử dụng ứng dụng.",
        image: ANDROID_GUIDE[6],
      },
    ],
    ios: [
      { image: IOS_GUIDE[0] },
      { image: IOS_GUIDE[1] },
      { image: IOS_GUIDE[2] },
      { image: IOS_GUIDE[3] },
      { image: IOS_GUIDE[4] },
      { image: IOS_GUIDE[5] },
      { image: IOS_GUIDE[6] },
      { image: IOS_GUIDE[7] },
      { image: IOS_GUIDE[8] },
    ],
  },
};

